import { useObserver } from 'mobx-react-lite';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useUser from 'src/hooks/use-user';
import { usePersonalizationEnabled } from 'src/utils/personalization/hooks/use-personalization-enabled';

/**
 * Single source of truth for whether the standalone "Buy it again" carousel should render on the
 * homepage. Both the legacy dispensary home and the core-menu (storefront/kiosk/embedded/mobile)
 * home consume this so the show-side can never drift from the hide-side again (ECOMM-11728).
 */
export function useShowBuyItAgainCarousel(): boolean {
  const user = useUser();
  const flags = useFlags();
  const isPersonalizationEnabled = usePersonalizationEnabled();

  const isLoggedIn = useObserver(() => user.isLoggedIn);
  const isPublicSessionPhoneLogin = useObserver(() => user?.isPublicSessionPhoneNumberLogin ?? false);
  const isBuyItAgainCarouselEnabled = flags['ecomm.buy-it-again-carousel.rollout'] ?? false;

  return isLoggedIn && !isPublicSessionPhoneLogin && isPersonalizationEnabled && isBuyItAgainCarouselEnabled;
}
